/**
 * Monotonic clock that works in every runtime the core supports.
 *
 * `performance` exists in browsers and in Node, but the published build is
 * compiled without DOM/Node type libraries, so it is read defensively.
 */
export const nowMs = (): number => {
  const perf = (globalThis as { performance?: { now?: () => number } }).performance;
  return typeof perf?.now === 'function' ? perf.now() : Date.now();
};
